module.exports = __webpack_public_path__ + "img/star.77b18919.svg";